// File: cgp-sidenav.component.ts
// Author: Joseph M Diaz
// Date: 5/10/2017
// Desc: Sidenav component. Items are loaded fromt he config file.
// Other Contributors:

import { Component, Input } from '@angular/core';

import { config } from '../../../config/config';
import { CgpSidenavService } from './cgp-sidenav.service';
import { AuthenticationService } from '../../auth.service';

@Component({
    selector: 'cgp-sidenav',
    templateUrl: './cgp-sidenav.template.html',
    styleUrls: ['./cgp-sidenav.style.scss']
})
export class CgpSidenavComponent {
    @Input('panelbar-hidden') panelbarHidden;
    items;
    module;

    constructor(
        public cgpSidenavService: CgpSidenavService,
        private readonly authService: AuthenticationService,
        ) {
            this.module = this.authService.getModule();
            this.cgpSidenavService.cgpSidenavComponent = this;

            const veComponents = this.getVeComponents(config.navItems);

            this.items = veComponents;
            this.items[0].isFirstItem = true;
            this.items[this.items.length - 1].isLastItem = true;
    }

    /**
     * Recursive function to parse veComponent Tree and validate which component the user has access to.
     * Invariant: TODO:
     * @private
     * @param {*} navItems
     * @returns array
     * @memberof CgpSidenavComponent
     */
    private getVeComponents(navItems) {
        return navItems.filter(veComponent => {
            if (veComponent.children) {
                const veComponentChildren = this.getVeComponents(veComponent.children);
                veComponentChildren.sort((a, b) => a.title.localeCompare(b.title)); // Sorting alphabetically.
                veComponent.children = veComponentChildren;
            }
            return (veComponent.module === this.module || veComponent.module === 'VE_Common') && this.authService.isClaimValid(veComponent);
        });
    }
}
